module.exports = __webpack_public_path__ + "static/about-content-image-1-37893dfe334d343737f9f4810627c4ff.jpg";